export const FIXED_WATER_PALETTE = {
  deep: "#1e2d30",
  base: "#233236",
  middle: "#4c5c61",
  ripple: "#697c82",
  highlight: "#74868b",
} as const;

export function waterColorAsGlsl(hex: string) {
  const normalized = hex.replace(/^#/, "");
  if (!/^[0-9a-f]{6}$/i.test(normalized)) throw new Error(`Invalid water palette color: ${hex}`);
  const channels = [0, 2, 4].map((offset) => Number.parseInt(normalized.slice(offset, offset + 2), 16) / 255);
  return `vec3(${channels.map((channel) => channel.toFixed(6)).join(", ")})`;
}
